import {CSSProperties, memo, useEffect} from 'react';
import {BarChart} from '@octavius-rocks/ui';
import Spinner from '../views/Spinner';
import {useQueryResultPageviews, useSubmitDashboardQuery} from '../../hook/useQuery';
import {useErrors} from '../../hook/useErrors';
import {useUiDashboardQueryIsLoading} from '../../hook/useUi';

type Props = {
    height: boolean | number
}

const PageviewsChart = (
    {
        height = false,
    }: Props
) => {

    const {value = [], oql = {}} = useQueryResultPageviews();
    const errors = useErrors();
    const [_, submit] = useSubmitDashboardQuery();
    const [isLoading] = useUiDashboardQueryIsLoading();
    const {aggregation} = oql;

    useEffect(() => {
        if (typeof oql === typeof {} && Object.keys(oql).length && !isLoading) {
            if (typeof submit == "function") submit();
        }
    }, []);

    if (value === false) {
        if (typeof errors != "undefined" && Array.isArray(errors) && errors.length > 0) {
            return (
                <ul>
                    {errors.map((error, index) => <li key={index}>{error}</li>)}
                </ul>
            );
        }
        return <div>Fehler bei der Anfrage an den Server</div>
    }

    const style: CSSProperties = {};
    if (typeof height == "number") {
        style.position = "relative";
        style.height = height;
    }

    const data = value.map(value => ({
        date: new Date(Date.parse(value.timestamp)),
        hits: value.hits,
    }));

    return <div style={style}>
        {isLoading ? <div style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: "rgba(255, 255, 255, 0.6)",
            textAlign: "center",
            paddingTop: 100,
            zIndex: 1,
        }}><Spinner/></div> : null}
        <BarChart
            height={typeof height == "number" ? height : undefined}
            data={data}
            timeUnit={aggregation}
        />
    </div>
};

export default memo(PageviewsChart);
